import OrderItemModel           from '@models/shop/OrderItemModel';
import ShippingMethodModel      from '@models/shop/ShippingMethodModel';
import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';
import ShopServiceModel         from '@/models/ShopServiceModel';
import TimestampAble            from '@widesk-core/models/traits/TimestampAble';
import Blamable                 from '@/models/traits/Blamable';
import OrderItemUnitStatusModel from '@models/shop/OrderItemUnitStatusModel';
import OrderItemUnitGroupModel  from '@models/shop/OrderItemUnitGroupModel';
import ProductVariantModel      from '@models/shop/ProductVariantModel';

@model.urnResource('order_item_unit')
@doc.path('/order_item_units/{?id}')
export default class OrderItemUnitModel extends Blamable(TimestampAble(ShopServiceModel)) {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'label': string;
		'orderItem': id;
		'orderItem.label': string;
		'orderItem.order': id;
		'orderItemUnitGroup': id;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.string declare label: string;
	@doc.model(OrderItemModel) declare orderItem: OrderItemModel;
	@doc.model(OrderItemUnitGroupModel) declare orderItemUnitGroup: OrderItemUnitGroupModel;
	@doc.model(OrderItemUnitStatusModel) declare orderItemUnitStatus: OrderItemUnitStatusModel;
	@doc.model(ProductVariantModel) declare productVariant: ProductVariantModel;
	@doc.model(ShippingMethodModel) declare shippingMethod: ShippingMethodModel;
}
// TODO DOC - Ajouter la propriété "source"